module.exports = __webpack_public_path__ + "img/banner.82cf7e6f.png";